import {
  GET_UNIVERSITIES,
  GET_UNIVERSITIES_FAILURE,
  GET_UNIVERSITIES_SUCCESS,
  GET_UNIVERSITIES_GRID,
  GET_UNIVERSITIES_GRID_SUCCESS,
  GET_UNIVERSITIES_GRID_FAILURE,
  GET_ALL_UNIVERSITIES,
  GET_ALL_UNIVERSITIES_FAILURE,
  GET_ALL_UNIVERSITIES_SUCCESS,
  GET_UNIVERSITY_DETAILS,
  GET_UNIVERSITY_DETAILS_FAILURE,
  GET_UNIVERSITY_DETAILS_SUCCESS,
  GET_UNIVERSITY_DETAILS_ADMIN,
  GET_UNIVERSITY_DETAILS_ADMIN_FAILURE,
  GET_UNIVERSITY_DETAILS_ADMIN_SUCCESS,
  GET_UNIS_BY_BUDGET,
  GET_UNIS_BY_BUDGET_SUCCESS,
  GET_UNIS_BY_BUDGET_FAILURE,
  GET_POPULAR_COUNTRIES,
  GET_POPULAR_COUNTRIES_SUCCESS,
  GET_POPULAR_COUNTRIES_FAILURE,
  GET_UNI_APPS_SHORTS,
  GET_UNI_APPS_SHORTS_SUCCESS,
  GET_UNI_APPS_SHORTS_FAILURE,
  ADD_UNIVERSITY,
  ADD_UNIVERSITY_SUCCESS,
  ADD_UNIVERSITY_FAILURE,
  ADD_UNIVERSITY_SHEET,
  ADD_UNIVERSITY_SHEET_SUCCESS,
  ADD_UNIVERSITY_SHEET_FAILURE,
  EDIT_UNIVERSITY,
  EDIT_UNIVERSITY_SUCCESS,
  EDIT_UNIVERSITY_FAILURE,
  UPLOAD_UNIVERSITY_IMAGES,
  UPLOAD_UNIVERSITY_IMAGES_SUCCESS,
  UPLOAD_UNIVERSITY_IMAGES_FAILURE,
} from "../constants";

const initialState = {
  count: 0,
  universities: [],
  allUniversities: [],
  topPicks: [],
  trending: [],
  popularInMyCountry: [],
  topBusiness: [],
  topMedicine: [],
  topLaw: [],
  topEngineering: [],
  topArtsAndHumanities: [],
  topPsychology: [],
  youMayLike: [],
  universitiesByBudget: [],
  popularCountries: [],
  university: {},
  universityAdmin: {},
  universityAppsShorts: {},
  isLoading: false,
  isUploadLoading: false,
  isAddLoading: false,
  isGridLoading: false,
  isPopularCountryLoading: false,
  isUniAppsShortsLoading: false,
  isUniByBudgetLoading: false,
  error: null,
};

export default function UniversityReducer(state = initialState, action) {
  switch (action.type) {
    case GET_UNIVERSITIES:
    case GET_ALL_UNIVERSITIES:
    case GET_UNIVERSITY_DETAILS:
    case GET_UNIVERSITY_DETAILS_ADMIN:
      state = {
        ...state,
        isLoading: true,
        error: null,
      };
      break;
    case ADD_UNIVERSITY:
    case ADD_UNIVERSITY_SHEET:
    case EDIT_UNIVERSITY:
      state = {
        ...state,
        isAddLoading: true,
        error: null,
      };
      break;
    case GET_UNIVERSITIES_GRID:
      state = {
        ...state,
        isGridLoading: true,
        error: null,
      };
      break;
    case UPLOAD_UNIVERSITY_IMAGES:
      state = {
        ...state,
        isUploadLoading: true,
        error: null,
      };
      break;
    case GET_UNI_APPS_SHORTS:
      state = {
        ...state,
        isUniAppsShortsLoading: true,
        error: null,
      };
      break;
    case GET_POPULAR_COUNTRIES:
      state = {
        ...state,
        isPopularCountryLoading: true,
        error: null,
      };
      break;
    case GET_UNIS_BY_BUDGET:
      state = {
        ...state,
        isUniByBudgetLoading: true,
        error: null,
      };
      break;
    case GET_UNIVERSITIES_SUCCESS:
      state = {
        ...state,
        count: action?.payload?.count,
        universities: action?.payload?.data,
        isLoading: false,
      };
      break;
    case GET_UNI_APPS_SHORTS_SUCCESS:
      state = {
        ...state,
        universityAppsShorts: action?.payload,
        isUniAppsShortsLoading: false,
      };
      break;
    case GET_UNIVERSITIES_GRID_SUCCESS:
      state = {
        ...state,
        count: action?.payload?.count,
        topPicks: action?.payload?.topPicks,
        trending: action?.payload?.trending,
        popularInMyCountry: action?.payload?.popularInMyCountry,
        topBusiness: action?.payload?.topBusiness,
        topMedicine: action?.payload?.topMedicine,
        topLaw: action?.payload?.topLaw,
        topEngineering: action?.payload?.topEngineering,
        topArtsAndHumanities: action?.payload?.topArtsAndHumanities,
        topPsychology: action?.payload?.topPsychology,
        youMayLike: action?.payload?.youMayLike,
        isGridLoading: false,
      };
      break;
    case GET_ALL_UNIVERSITIES_SUCCESS:
      state = {
        ...state,
        allUniversities: action?.payload,
        isLoading: false,
      };
      break;
    case ADD_UNIVERSITY_SUCCESS:
    case ADD_UNIVERSITY_SHEET_SUCCESS:
    case EDIT_UNIVERSITY_SUCCESS:
      state = {
        ...state,
        isAddLoading: false,
        error: null,
      };
      break;
    case UPLOAD_UNIVERSITY_IMAGES_SUCCESS:
      state = {
        ...state,
        isUploadLoading: false,
        error: null,
      };
      break;
    case GET_POPULAR_COUNTRIES_SUCCESS:
      state = {
        ...state,
        popularCountries: action?.payload,
        isPopularCountryLoading: false,
      };
      break;
    case GET_UNIS_BY_BUDGET_SUCCESS:
      state = {
        ...state,
        universitiesByBudget: action?.payload,
        isUniByBudgetLoading: false,
      };
      break;
    case GET_UNIVERSITY_DETAILS_SUCCESS:
      state = {
        ...state,
        university: action.payload,
        isLoading: false,
      };
      break;
    case GET_UNIVERSITY_DETAILS_ADMIN_SUCCESS:
      state = {
        ...state,
        universityAdmin: action.payload,
        isLoading: false,
      };
      break;
    case GET_UNIVERSITIES_FAILURE:
    case GET_ALL_UNIVERSITIES_FAILURE:
    case GET_UNIVERSITY_DETAILS_FAILURE:
    case GET_UNIVERSITY_DETAILS_ADMIN_FAILURE:
      state = {
        ...state,
        isLoading: false,
      };
      break;
    case GET_UNIVERSITIES_GRID_FAILURE:
      state = {
        ...state,
        isGridLoading: false,
      };
      break;
    case UPLOAD_UNIVERSITY_IMAGES_FAILURE:
      state = {
        ...state,
        isUploadLoading: false,
        error: null,
      };
      break;
    case ADD_UNIVERSITY_FAILURE:
    case ADD_UNIVERSITY_SHEET_FAILURE:
    case EDIT_UNIVERSITY_FAILURE:
      state = {
        ...state,
        isAddLoading: false,
        error: null,
      };
      break;
    case GET_UNI_APPS_SHORTS_FAILURE:
      state = {
        ...state,
        isUniAppsShortsLoading: false,
      };
      break;
    case GET_POPULAR_COUNTRIES_FAILURE:
      state = {
        ...state,
        isPopularCountryLoading: false,
      };
      break;
    case GET_UNIS_BY_BUDGET_FAILURE:
      state = {
        ...state,
        isUniByBudgetLoading: false,
      };
      break;
    default:
      break;
  }
  return state;
}
